import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import { X_AT_KEY } from './api';
import getPhotoSizeServerFromDimensions from './getPhotoSizeServerFromDimensions';

type Args = {
  baseUrl?: string;
  id: string | number;
  showWatermark?: boolean;
  size: PhotoSizeDimensions | { width: number; height: number };
};

const getPhotoUrlFromId = ({ baseUrl, id, showWatermark = false, size }: Args) => {
  const params = new URLSearchParams();
  params.set('key', X_AT_KEY);

  if (showWatermark) {
    params.set('show_watermark', 'true');
  }

  const sizeString = typeof size === 'string' ? getPhotoSizeServerFromDimensions(size) : `${size.width}w${size.height}h`;
  params.set('size', sizeString);

  return `${baseUrl || ''}/api/alltrails/photos/${id}/image?${params.toString()}`;
};

export default getPhotoUrlFromId;
